// extracted by mini-css-extract-plugin
export default {"modeTabs":"view_tabs-module___modeTabs___a7916e20","tab":"view_tabs-module___tab___fa37f25f"};